import React from "react";

/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { ReactComponent as Cle } from "./icons8-clé.svg"; // Import SVG as React component
import { ReactComponent as CodeFile } from "./icons8-code-file.svg"; // Import SVG as React component
import { ReactComponent as CompteMarchand } from "./icons8-compte-marchand.svg"; // Import SVG as React component
import { ReactComponent as Content } from "./icons8-content.svg"; // Import SVG as React component
import { ReactComponent as CurseurMain } from "./icons8-curseur-main.svg"; // Import SVG as React component
import { ReactComponent as Curseur } from "./icons8-curseur.svg"; // Import SVG as React component
import { ReactComponent as Smartphone } from "./icons8-iphone-x.svg"; // Import SVG as React component
import { ReactComponent as DeuxSmartphone } from "./icons8-deux-smartphones.svg"; // Import SVG as React component
import { ReactComponent as Done } from "./icons8-done-50.svg"; // Import SVG as React component
import { ReactComponent as Download } from "./icons8-download-50.svg"; // Import SVG as React component
import { ReactComponent as Effacer } from "./icons8-effacer.svg"; // Import SVG as React component
import { ReactComponent as Email } from "./icons8-email.svg"; // Import SVG as React component
import { ReactComponent as ErreurOrdinateur } from "./icons8-erreur-d&#39;ordinateur-portable.svg"; // Import SVG as React component
import { ReactComponent as Erreur } from "./icons8-erreur.svg"; // Import SVG as React component
import { ReactComponent as Admin } from "./icons8-expert.svg"; // Import SVG as React component
import { ReactComponent as Expert } from "./icons8-ingénieur.svg"; // Import SVG as React component

import { ReactComponent as Hexagone } from "./HexagoneFav451_black.svg"; // Import SVG as React component
import { ReactComponent as Hexagone2 } from "./HexaGoneFull.svg"; // Import SVG as React component
import { ReactComponent as Home } from "./icons8-home-50.svg"; // Import SVG as React component
import { ReactComponent as Message } from "./icons8-speech-bubble-50.svg"; // Import SVG as React component
import { ReactComponent as Folder } from "./icons8-folder-50.svg"; // Import SVG as React component
import { ReactComponent as Facture } from "./icons8-facture.svg"; // Import SVG as React component
import { ReactComponent as User } from "./icons8-utilisateur (1).svg"; // Import SVG as React component
import { ReactComponent as Client } from "./icons8-client.svg"; // Import SVG as React component

import { ReactComponent as Intervenant } from "./icons8-expert.svg"; // Import SVG as React component
import { ReactComponent as Settings } from "./icons8-settings-50.svg"; // Import SVG as React component
import { ReactComponent as SettingsFilled } from "./icons8-settings.svg"; // Import SVG as React component

import { ReactComponent as Devis } from "./icons8-ordre-d'achat (2).svg"; // Import SVG as React component
import { ReactComponent as Tag } from "./icons8-étiquette-de-prix (2).svg"; // Import SVG as React component
import { ReactComponent as Filtre } from "./icons8-filtre (2).svg"; // Import SVG as React component
import { ReactComponent as Integration } from "./icons8-puzzle.svg"; // Import SVG as React component
import { ReactComponent as Boutique } from "./icons8-compte-marchand.svg"; // Import SVG as React component
import { ReactComponent as Facturation } from "./icons8-carte-bancaire-dollar.svg"; // Import SVG as React component
import { ReactComponent as Logout } from "./icons8-logout-50.svg"; // Import SVG as React component
import { ReactComponent as Question } from "./icons8-question.svg"; // Import SVG as React component
import { ReactComponent as FullScreen } from "./icons8-plein-écran.svg"; // Import SVG as React component
import { ReactComponent as Heure } from "./icons8-heure-de-livraison.svg"; // Import SVG as React component
import { ReactComponent as Horloge } from "./icons8-horloge.svg"; // Import SVG as React component
import { ReactComponent as Cloche } from "./icons8-rappels-de-rendez-vous.svg"; // Import SVG as React component
import { ReactComponent as Logs } from "./icons8-liste-des-transactions.svg"; // Import SVG as React component
import { ReactComponent as Search } from "./icons8-chercher.svg"; // Import SVG as React component
import { ReactComponent as Close } from "./icons8-effacer.svg"; // Import SVG as React component
import { ReactComponent as Right } from "./icons8-vers-l'avant.svg"; // Import SVG as React component
import { ReactComponent as Left } from "./icons8-arrière.svg"; // Import SVG as React component
import { ReactComponent as Menu } from "./icons8-menu.svg"; // Import SVG as React component
import { ReactComponent as Modify } from "./icons8-modifier.svg"; // Import SVG as React component
import { ReactComponent as Delete } from "./icons8-trash-can-50.svg"; // Import SVG as React component
import { ReactComponent as Plus } from "./icons8-plus-math-50.svg"; // Import SVG as React component
import { ReactComponent as Minus } from "./icons8-moins.svg"; // Import SVG as React component
import { ReactComponent as Planning } from "./icons8-calendrier.svg"; // Import SVG as React component
import { ReactComponent as PDF } from "./icons8-pdf.svg"; // Import SVG as React component
import { ReactComponent as Join } from "./icons8-trombone.svg"; // Import SVG as React component
import { ReactComponent as Restauration } from "./icons8-restauration.svg"; // Import SVG as React component
import { ReactComponent as Rapport } from "./icons8-test-results-50.svg"; // Import SVG as React component
import { ReactComponent as Share } from "./icons8-transférer.svg"; // Import SVG as React component
import { ReactComponent as Share2 } from "./icons8-partager.svg"; // Import SVG as React component
import { ReactComponent as Archive } from "./icons8-classeur.svg"; // Import SVG as React component
import { ReactComponent as Date } from "./icons8-calendrier-12.svg"; // Import SVG as React component
import { ReactComponent as Organisation } from "./icons8-organisation.svg"; // Import SVG as React component
import { ReactComponent as Pinceau } from "./icons8-pinceau.svg"; // Import SVG as React component
import { ReactComponent as DeuxSmartphones } from "./icons8-deux-smartphones.svg"; // Import SVG as React component
import { ReactComponent as TestResults } from "./icons8-test-results-50.svg"; // Import SVG as React component
import { ReactComponent as NouveauMessage } from "./icons8-nouveau-message.svg"; // Import SVG as React component
import { ReactComponent as Sign } from "./icons8-main-avec-stylo.svg"; // Import SVG as React component
import { ReactComponent as Send } from "./icons8-envoyé.svg"; // Import SVG as React component
import { ReactComponent as Image } from "./icons8-image.svg"; // Import SVG as React component
import { ReactComponent as Youtube } from "./icons8-youtube.svg"; // Import SVG as React component
import { ReactComponent as Education } from "./icons8-chapeau-de-diplôme.svg"; // Import SVG as React component
import { ReactComponent as Lock } from "./icons8-lock-50.svg"; // Import SVG as React component
import { ReactComponent as Down } from "./icons8-flèche-développer.svg"; // Import SVG as React component
import { ReactComponent as Down2 } from "./icons8-sort-down.svg"; // Import SVG as React component
import { ReactComponent as Up2 } from "./icons8-sort-up.svg"; // Import SVG as React component

import { ReactComponent as Up } from "./icons8-flèche-réduire.svg"; // Import SVG as React component
import { ReactComponent as Tampon } from "./icons8-tampon-encreur.svg"; // Import SVG as React component
import { ReactComponent as Warning } from "./icons8-attention.svg"; // Import SVG as React component
import { ReactComponent as Param } from "./icons8-paramètres (1).svg"; // Import SVG as React component
import { ReactComponent as Done2 } from "./icons8-ok.svg"; // Import SVG as React component
import { ReactComponent as Done3 } from "./icons8-badge-vérifié.svg"; // Import SVG as React component
import { ReactComponent as Done4 } from "./icons8-verified-badge.svg"; // Import SVG as React component
import { ReactComponent as Mean } from "./icons8-calculatrice.svg"; // Import SVG as React component
import { ReactComponent as Taux } from "./icons8-pourcentage.svg"; // Import SVG as React component
import { ReactComponent as Restart } from "./icons8-redémarrer.svg"; // Import SVG as React component
import { ReactComponent as Late } from "./icons8-présent.svg"; // Import SVG as React component
import { ReactComponent as Text } from "./icons8-texte.svg"; // Import SVG as React component
import { ReactComponent as Response } from "./icons8-flèche-répondre-à-tous.svg"; // Import SVG as React component
import { ReactComponent as Cloud } from "./icons8-nuage-droit.svg"; // Import SVG as React component
import { ReactComponent as File } from "./icons8-document.svg"; // Import SVG as React component
import { ReactComponent as Photo } from "./icons8-unsplash.svg"; // Import SVG as React component
import { ReactComponent as Copy } from "./icons8-copie.svg"; // Import SVG as React component
import { ReactComponent as RTB2 } from "./icons8-lire-le-rapport-de-diagramme-circulaire.svg"; // Import SVG as React component
import { ReactComponent as Unlock } from "./icons8-ouvrir.svg"; // Import SVG as React component
import { ReactComponent as Products } from "./icons8-paramètre-de-magasin.svg"; // Import SVG as React component
import { ReactComponent as Xml } from "./icons8-xml.svg"; // Import SVG as React component
import { ReactComponent as Chauffage } from "./icons8-chauffage-de-pièce.svg"; // Import SVG as React component
import { ReactComponent as PlusEgal } from "./icons8-plus-ou-égal.svg"; // Import SVG as React component
import { ReactComponent as MoinsEgal } from "./icons8-moins-ou-égal.svg"; // Import SVG as React component
import { ReactComponent as Convert } from "./icons8-convertir.svg"; // Import SVG as React component
import { ReactComponent as RTB } from "./icons8-robot.svg"; // Import SVG as React component
import { ReactComponent as Phone } from "./icons8-téléphone.svg"; // Import SVG as React component
import { ReactComponent as Eye } from "./icons8-visible.svg"; // Import SVG as React component
import { ReactComponent as Invisible } from "./icons8-invisible.svg"; // Import SVG as React component

import { ReactComponent as Bad } from "./icons8-pouces-vers-le-bas.svg"; // Import SVG as React component

import { ReactComponent as Assistant } from "./icons8-assistant.svg"; // Import SVG as React component
import { ReactComponent as Tool } from "./icons8-couteau-suisse.svg"; // Import SVG as React component
import { ReactComponent as Hand } from "./icons8-poing-serré.svg"; // Import SVG as React component
import { ReactComponent as Administratif } from "./icons8-pile-de-papier.svg"; // Import SVG as React component
import { ReactComponent as NoWeb } from "./icons8-pas-de-web.svg"; // Import SVG as React component
import { ReactComponent as Automatic } from "./icons8-automatique.svg"; // Import SVG as React component

import { ReactComponent as Good } from "./icons8-pouce-en-l'air.svg"; // Import SVG as React component
import { ReactComponent as Secure } from "./icons8-sécurité-vérifiée.svg"; // Import SVG as React component
import { ReactComponent as Storage } from "./icons8-stockage.svg"; // Import SVG as React component
import { ReactComponent as ESign } from "./icons8-signature-numérique.svg"; // Import SVG as React component

import { ReactComponent as Control } from "./icons8-graphique-de-la-santé.svg"; // Import SVG as React component
import { ReactComponent as Position } from "./icons8-marqueur.svg"; // Import SVG as React component
import { ReactComponent as Stats } from "./icons8-graphique-combiné.svg"; // Import SVG as React component
import { ReactComponent as Plane } from "./icons8-hors-ligne.svg"; // Import SVG as React component
import { ReactComponent as Document } from "./icons8-document.svg"; // Import SVG as React component
import { ReactComponent as MobileMenu } from "./icons8-menu (1).svg"; // Import SVG as React component
import { ReactComponent as Collaboration } from "./icons8-collaboration.svg"; // Import SVG as React component
import { ReactComponent as Forum } from "./icons8-forum.svg"; // Import SVG as React component
import { ReactComponent as Forbidden } from "./icons8-annuler-2.svg"; // Import SVG as React component
import { ReactComponent as Equal } from "./icons8-signe-égal.svg"; // Import SVG as React component
import { ReactComponent as Invite } from "./icons8-invitation.svg"; // Import SVG as React component
import { ReactComponent as Payments } from "./icons8-machine-à-facturer.svg"; // Import SVG as React component
import { ReactComponent as LinkedFile } from "./icons8-fichier-lié.svg"; // Import SVG as React component
import { ReactComponent as CheckedDocFill } from "./icons8-check-document.svg"; // Import SVG as React component
import { ReactComponent as CheckedDoc } from "./icons8-check-document (1).svg"; // Import SVG as React component
import { ReactComponent as Car } from "./icons8-berline.svg"; // Import SVG as React component
import { ReactComponent as Position2 } from "./icons8-adresse.svg"; // Import SVG as React component
import { ReactComponent as Pizza } from "./icons8-pizza.svg"; // Import SVG as React component
import { ReactComponent as Transactions } from "./icons8-données-dans-les-deux-directions.svg"; // Import SVG as React component
import { ReactComponent as Back } from "./icons8-flèche-gauche.svg"; // Import SVG as React component
import { ReactComponent as Stars } from "./icons8-pétillant (1).svg"; // Import SVG as React component
import { ReactComponent as Star } from "./icons8-étoile.svg"; // Import SVG as React component
import { ReactComponent as Trello } from "./icons8-semaine-de-la-chronologie.svg"; // Import SVG as React component
import { ReactComponent as MobileCotrol } from "./icons8-installation-de-phonelink.svg"; // Import SVG as React component
import { ReactComponent as Pack } from "./icons8-paramètres-du-dossier.svg"; // Import SVG as React component
import { ReactComponent as AI } from "./icons8-ai.svg"; // Import SVG as React component
import { ReactComponent as Pin } from "./icons8-épingle.svg"; // Import SVG as React component
import { ReactComponent as UnPin } from "./icons8-détacher.svg"; // Import SVG as React component
import { ReactComponent as Cursor } from "./icons8-curseur-setup.svg"; // Import SVG as React component
import { ReactComponent as Pennylane } from "./pennylane.svg"; // Import SVG as React component
import { ReactComponent as GoodFilled } from "./icons8-thumbs-up.svg"; // Import SVG as React component
import { ReactComponent as BadFilled } from "./icons8-thumbs-down.svg"; // Import SVG as React component
import { ReactComponent as Rocket } from "./icons8-fusée (1).svg"; // Import SVG as React component
import { ReactComponent as Infiltrometre } from "./icons8-homme-populaire.svg"; // Import SVG as React component
import { ReactComponent as Stripe } from "./icons8-stripe (1).svg"; // Import SVG as React component
import { ReactComponent as Bridge } from "./bridge_logo.svg";
import { ReactComponent as Bookshelf } from "./icons8-bibliothèque.svg"; // Import SVG as React component
import { ReactComponent as OBBC } from "./icons8-triangle.svg"; // Import SVG as React component
import { ReactComponent as Desktop } from "./icons8-imac (1).svg"; // Import SVG as React component
import { ReactComponent as Infini } from "./icons8-infini.svg"; // Import SVG as React component
import { ReactComponent as Resize } from "./icons8-redimensionner-en-diagonal.svg"; // Import SVG as React component
import { ReactComponent as ATHIcon } from "./icons8-signer-un-document.svg"; // Import SVG as React component
import { ReactComponent as ATHSPEIcon } from "./icons8-signer-un-document (2).svg"; // Import SVG as React component
import { ReactComponent as DoubleLeft } from "./icons8-double-gauche.svg"; // Import SVG as React component
import { ReactComponent as DoubleRight } from "./icons8-double-droite.svg"; // Import SVG as React component
import { ReactComponent as Iframe } from "./icons8-navigateur-internet.svg"; // Import SVG as React component
import { ReactComponent as HexagoneLogement } from "./hexagone/hexaogne-logement-ready.svg"; // Import SVG as React component
import { ReactComponent as HexagoneAudit } from "./hexagone/hexaogne-audit-ready.svg"; // Import SVG as React component
import { ReactComponent as HexagoneInfiltro } from "./hexagone/hexagone-infiltro-ready.svg"; // Import SVG as React component
import { ReactComponent as HexagoneThermo } from "./hexagone/hexagone-thermo-ready.svg"; // Import SVG as React component
import { ReactComponent as HexagoneBasique } from "./hexagone/hexagone-basique-ready.svg"; // Import SVG as React component
import { ReactComponent as HexagoneLight } from "./hexagone/hexagone-light-ready.svg"; // Import SVG as React component
import { ReactComponent as Workspace } from "./icons8-bureau-à-domicile.svg"; // Import SVG as React component
import { ReactComponent as Replace } from "./icons8-remplacer.svg"; // Import SVG as React component
import { ReactComponent as Flag } from "./icons8-drapeau-2.svg"; // Import SVG as React component
import { ReactComponent as Link } from "./icons8-lien.svg"; // Import SVG as React component
import { ReactComponent as FileError } from "./icons8-document (1).svg"; // Import SVG as React component
import { ReactComponent as FileSuccess } from "./icons8-document (2).svg"; // Import SVG as React component
import { ReactComponent as Task } from "./icons8-a-faire.svg"; // Import SVG as React component
import { ReactComponent as Paste } from "./icons8-coller.svg"; // Import SVG as React component
import { ReactComponent as Filters } from "./icons8-réglages-horizontal.svg"; // Import SVG as React component

import { ReactComponent as Room } from "./icons8-chambre.svg"; // Import SVG as React component
import { ReactComponent as Appareil } from "./icons8-anémomètre.svg"; // Import SVG as React component
import { ReactComponent as Calibration } from "./icons8-vitesse (1).svg"; // Import SVG as React component
import { ReactComponent as System } from "./icons8-climatisation (1).svg"; // Import SVG as React component
import { ReactComponent as Batiment } from "./icons8-bâtiment (1).svg"; // Import SVG as React component
import { ReactComponent as Ensemble } from "./icons8-bâtiments-de-la-ville (1).svg"; // Import SVG as React component
import { ReactComponent as Bath } from "./icons8-douche-et-baignoire (1).svg"; // Import SVG as React component
import { ReactComponent as WC } from "./icons8-cuvette-des-toilettes (1).svg"; // Import SVG as React component
import { ReactComponent as NonConforme } from "./icons8-annuler (1).svg"; // Import SVG as React component
import { ReactComponent as Conforme } from "./icons8-ok (1).svg"; // Import SVG as React component
import { ReactComponent as Inconnu } from "./icons8-aide.svg"; // Import SVG as React component
import { ReactComponent as Caisson } from "./icons8-qualité-de-l'air (1).svg"; // Import SVG as React component
import { ReactComponent as Guide } from "./icons8-guide.svg"; // Import SVG as React component
import { ReactComponent as Escalier } from "./icons8-escalier.svg"; // Import SVG as React component
import { ReactComponent as SimpleFlux } from "./icons8-avance.svg"; // Import SVG as React component
import { ReactComponent as DoubleFlux } from "./icons8-flèches-tri-horizontal.svg"; // Import SVG as React component
import { ReactComponent as Individuelle } from "./icons8-arrêter-encadré.svg"; // Import SVG as React component
import { ReactComponent as Mutualisee } from "./icons8-diffusion.svg"; // Import SVG as React component
import { ReactComponent as Logement } from "./icons8-porte-ouverte.svg"; // Import SVG as React component
import { ReactComponent as Pression } from "./icons8-pression.svg"; // Import SVG as React component
import { ReactComponent as Debit } from "./icons8-élément-air (1).svg"; // Import SVG as React component
import { ReactComponent as Entree } from "./icons8-touche-entrée.svg"; // Import SVG as React component
import { ReactComponent as Cuisine } from "./icons8-frigo.svg"; // Import SVG as React component
import { ReactComponent as Table } from "./icons8-table.svg"; // Import SVG as React component
import { ReactComponent as Renovation } from "./icons8-rouleau-à-peinture.svg"; // Import SVG as React component
import { ReactComponent as Extension } from "./icons8-tous-dehors.svg"; // Import SVG as React component
import { ReactComponent as Plume } from "./icons8-rempli-en-plumes (1).svg"; // Import SVG as React component
import { ReactComponent as Gallery } from "./icons8-galerie.svg"; // Import SVG as React component

/**
 * @param {Object} props
 * @param {string} [props.icon_name="clé"]
 * @param {string} [props.width="20px"]
 * @param {string} [props.height="20px"]
 * @param {number} [props.size=20]
 * @param {string} [props.fill="black"]
 * @param {string} [props.margin="0px"]
 * @param {string} [props.padding="0px"]
 * @param {string} [props.hover_color]
 * @param {Object} [props.sx]
 * @param {boolean} [props.parent_hover=false] - If true, the hover effect applies when the parent element with 'group' class is hovered.
 */
function Icon1({
  icon_name = "clé",
  width = "20px",
  height = "20px",
  size = 20,
  fill = "black",
  margin = "0px",
  padding = "0px",
  hover_color,
  parent_hover = false, //

  sx,
}) {
  if (size) {
    width = `${size}px`;
    height = `${size}px`;
  }

  const style = css({
    width,
    height,
    fill,
    margin,
    padding,
    transition: "fill 0.2s ease", // Smooth transition for hover effect

    // Conditional hover behavior
    ...(hover_color &&
      (parent_hover
        ? {
            // Parent hover - triggers when parent with 'group' class is hovered
            ".group:hover &": {
              fill: hover_color,
            },
          }
        : {
            // Self hover - original behavior
            "&:hover": {
              fill: hover_color,
            },
          })),
  });

  let html;
  if (icon_name === "photo") html = <Photo css={style} />;
  if (icon_name === "file") html = <File css={style} />;
  if (icon_name === "clé") html = <Cle css={style} sx={{ ...sx }} />;
  if (icon_name === "code-file") html = <CodeFile css={style} />;
  if (icon_name === "compte-marchand") html = <CompteMarchand css={style} />;
  if (icon_name === "content") html = <Content css={style} />;
  if (icon_name === "curseur-main") html = <CurseurMain css={style} />;
  if (icon_name === "curseur") html = <Curseur css={style} />;
  if (icon_name === "deux-smartphones") html = <DeuxSmartphone css={style} />;
  if (icon_name === "done") html = <Done css={style} />;
  if (icon_name === "download") html = <Download css={style} />;
  if (icon_name === "effacer") html = <Effacer css={style} />;
  if (icon_name === "email") html = <Email css={style} />;
  if (icon_name === "erreur-ordinateur")
    html = <ErreurOrdinateur css={style} />;
  if (icon_name === "erreur") html = <Erreur css={style} />;
  if (icon_name === "expert") html = <Expert css={style} />;
  if (icon_name === "hexagone") html = <Hexagone css={style} />;
  if (icon_name === "hexagone2") html = <Hexagone2 css={style} />;
  if (icon_name === "home") html = <Home css={style} sx={{ ...sx }} />;
  if (icon_name === "message") html = <Message css={style} />;
  if (icon_name === "folder") html = <Folder css={style} />;
  if (icon_name === "facture") html = <Facture css={style} />;
  if (icon_name === "client") html = <Client css={style} />;
  if (icon_name === "intervenant") html = <Intervenant css={style} />;
  if (icon_name === "settings") html = <Settings css={style} />;
  if (icon_name === "settings-filled") html = <SettingsFilled css={style} />;

  if (icon_name === "devis") html = <Devis css={style} />;
  if (icon_name === "tag") html = <Tag css={style} />;
  if (icon_name === "filtre") html = <Filtre css={style} />;
  if (icon_name === "integration") html = <Integration css={style} />;
  if (icon_name === "facturation") html = <Facturation css={style} />;
  if (icon_name === "logout") html = <Logout css={style} />;
  if (icon_name === "question") html = <Question css={style} />;
  if (icon_name === "full-screen") html = <FullScreen css={style} />;
  if (icon_name === "heure") html = <Heure css={style} />;
  if (icon_name === "horloge") html = <Horloge css={style} />;
  if (icon_name === "cloche") html = <Cloche css={style} />;
  if (icon_name === "logs") html = <Logs css={style} />;
  if (icon_name === "search") html = <Search css={style} />;
  if (icon_name === "close") html = <Close css={style} />;
  if (icon_name === "right") html = <Right css={style} />;
  if (icon_name === "left") html = <Left css={style} />;
  if (icon_name === "menu") html = <Menu css={style} />;
  if (icon_name === "modify") html = <Modify css={style} />;
  if (icon_name === "delete") html = <Delete css={style} />;
  if (icon_name === "plus") html = <Plus css={style} />;
  if (icon_name === "minus") html = <Minus css={style} />;
  if (icon_name === "planning") html = <Planning css={style} />;
  if (icon_name === "pdf") html = <PDF css={style} />;
  if (icon_name === "join") html = <Join css={style} />;
  if (icon_name === "restauration") html = <Restauration css={style} />;
  if (icon_name === "rapport") html = <Rapport css={style} />;
  if (icon_name === "share") html = <Share css={style} />;
  if (icon_name === "share2") html = <Share2 css={style} />;
  if (icon_name === "archive") html = <Archive css={style} />;
  if (icon_name === "date") html = <Date css={style} />;
  if (icon_name === "organisation") html = <Organisation css={style} />;
  if (icon_name === "pinceau") html = <Pinceau css={style} />;
  if (icon_name === "deux-smartphones") html = <DeuxSmartphones css={style} />;
  if (icon_name === "test-results") html = <TestResults css={style} />;
  if (icon_name === "nouveau-message") html = <NouveauMessage css={style} />;
  if (icon_name === "sign") html = <Sign css={style} />;
  if (icon_name === "send") html = <Send css={style} />;
  if (icon_name === "image") html = <Image css={style} />;
  if (icon_name === "smartphone") html = <Smartphone css={style} />;
  if (icon_name === "youtube") html = <Youtube css={style} />;
  if (icon_name === "education") html = <Education css={style} />;
  if (icon_name === "lock") html = <Lock css={style} />;
  if (icon_name === "down") html = <Down css={style} />;
  if (icon_name === "down2") html = <Down2 css={style} />;

  if (icon_name === "up") html = <Up css={style} />;
  if (icon_name === "up2") html = <Up2 css={style} />;

  if (icon_name === "tampon") html = <Tampon css={style} />;
  if (icon_name === "warning") html = <Warning css={style} />;
  if (icon_name === "param") html = <Param css={style} />;
  if (icon_name === "done2") html = <Done2 css={style} />;
  if (icon_name === "done3") html = <Done3 css={style} />;
  if (icon_name === "done4") html = <Done4 css={style} />;
  if (icon_name === "mean") html = <Mean css={style} />;
  if (icon_name === "taux") html = <Taux css={style} />;
  if (icon_name === "restart") html = <Restart css={style} />;
  if (icon_name === "late") html = <Late css={style} />;
  if (icon_name === "text") html = <Text css={style} />;
  if (icon_name === "response") html = <Response css={style} />;
  if (icon_name === "cloud") html = <Cloud css={style} />;
  if (icon_name === "copy") html = <Copy css={style} />;
  if (icon_name === "rtb") html = <RTB css={style} />;
  if (icon_name === "unlock") html = <Unlock css={style} />;
  if (icon_name === "products") html = <Products css={style} />;
  if (icon_name === "xml") html = <Xml css={style} />;
  if (icon_name === "chauffage") html = <Chauffage css={style} />;
  if (icon_name === "plus-egal") html = <PlusEgal css={style} />;
  if (icon_name === "moins-egal") html = <MoinsEgal css={style} />;
  if (icon_name === "user") html = <User css={style} />;

  if (icon_name === "convert") html = <Convert css={style} />;
  if (icon_name === "admin") html = <Admin css={style} />;
  if (icon_name === "phone") html = <Phone css={style} />;

  if (icon_name === "eye") html = <Eye css={style} />;
  if (icon_name === "bad") html = <Bad css={style} />;

  if (icon_name === "assistant") html = <Assistant css={style} />;
  if (icon_name === "tool") html = <Tool css={style} />;
  if (icon_name === "hand") html = <Hand css={style} />;
  if (icon_name === "administratif") html = <Administratif css={style} />;
  if (icon_name === "no-web") html = <NoWeb css={style} />;
  if (icon_name === "automatic") html = <Automatic css={style} />;
  if (icon_name === "good") html = <Good css={style} />;
  if (icon_name === "secure") html = <Secure css={style} />;
  if (icon_name === "storage") html = <Storage css={style} />;
  if (icon_name === "esign") html = <ESign css={style} />;

  if (icon_name === "control") html = <Control css={style} />;
  if (icon_name === "stats") html = <Stats css={style} />;
  if (icon_name === "plane") html = <Plane css={style} />;
  if (icon_name === "document") html = <Document css={style} />;
  if (icon_name === "mobilemenu") html = <MobileMenu css={style} />;
  if (icon_name === "collaboration") html = <Collaboration css={style} />;
  if (icon_name === "invisible") html = <Invisible css={style} />;
  if (icon_name === "forum") html = <Forum css={style} />;
  if (icon_name === "forbidden") html = <Forbidden css={style} />;
  if (icon_name === "equal") html = <Equal css={style} />;
  if (icon_name === "invite") html = <Invite css={style} />;
  if (icon_name === "payments") html = <Payments css={style} />;
  if (icon_name === "linked_file") html = <LinkedFile css={style} />;
  if (icon_name === "checked_doc") html = <CheckedDoc css={style} />;
  if (icon_name === "checked_doc_fill") html = <CheckedDocFill css={style} />;
  if (icon_name === "car") html = <Car css={style} />;
  if (icon_name === "position") html = <Position css={style} />;
  if (icon_name === "pizza") html = <Pizza css={style} />;
  if (icon_name === "transactions") html = <Transactions css={style} />;
  if (icon_name === "back") html = <Back css={style} />;
  if (icon_name === "stars") html = <Stars css={style} />;
  if (icon_name === "star") html = <Star css={style} />;
  if (icon_name === "trello") html = <Trello css={style} />;
  if (icon_name === "mobile-control") html = <MobileCotrol css={style} />;
  if (icon_name === "pack") html = <Pack css={style} />;
  if (icon_name === "ai") html = <AI css={style} />;
  if (icon_name === "pin") html = <Pin css={style} />;
  if (icon_name === "unpin") html = <UnPin css={style} />;
  if (icon_name === "cursor") html = <Cursor css={style} />;
  if (icon_name === "pennylane") html = <Pennylane css={style} />;
  if (icon_name === "good-filled") html = <GoodFilled css={style} />;
  if (icon_name === "bad-filled") html = <BadFilled css={style} />;
  if (icon_name === "rocket") html = <Rocket css={style} />;
  if (icon_name === "infiltrometre") html = <Infiltrometre css={style} />;
  if (icon_name === "stripe") html = <Stripe css={style} />;
  if (icon_name === "bookshelf") html = <Bookshelf css={style} />;
  if (icon_name === "obbc") html = <OBBC css={style} />;
  if (icon_name === "desktop") html = <Desktop css={style} />;
  if (icon_name === "infini") html = <Infini css={style} />;
  if (icon_name === "resize") html = <Resize css={style} />;
  if (icon_name === "ath") html = <ATHIcon css={style} />;
  if (icon_name === "athspe") html = <ATHSPEIcon css={style} />;
  if (icon_name === "doubleleft") html = <DoubleLeft css={style} />;
  if (icon_name === "doubleright") html = <DoubleRight css={style} />;
  if (icon_name === "iframe") html = <Iframe css={style} />;
  if (icon_name === "bridge") html = <Bridge css={style} />;

  if (icon_name === "hexagone-logement")
    html = <HexagoneLogement css={style} />;
  if (icon_name === "hexagone-audit") html = <HexagoneAudit css={style} />;
  if (icon_name === "hexagone-infiltro")
    html = <HexagoneInfiltro css={style} />;
  if (icon_name === "hexagone-thermo") html = <HexagoneThermo css={style} />;
  if (icon_name === "hexagone-basique") html = <HexagoneBasique css={style} />;
  if (icon_name === "hexagone-light") html = <HexagoneLight css={style} />;
  if (icon_name === "workspace") html = <Workspace css={style} />;
  if (icon_name === "replace") html = <Replace css={style} />;
  if (icon_name === "flag") html = <Flag css={style} />;
  if (icon_name === "link") html = <Link css={style} />;
  if (icon_name === "file-error") html = <FileError css={style} />;
  if (icon_name === "file-success") html = <FileSuccess css={style} />;
  if (icon_name === "task") html = <Task css={style} />;
  if (icon_name === "paste") html = <Paste css={style} />;
  if (icon_name === "filters") html = <Filters css={style} />;

  if (icon_name === "room") html = <Room css={style} />;
  if (icon_name === "appareil") html = <Appareil css={style} />;
  if (icon_name === "calibration") html = <Calibration css={style} />;
  if (icon_name === "system") html = <System css={style} />;
  if (icon_name === "logement") html = <Logement css={style} />;
  if (icon_name === "batiment") html = <Batiment css={style} />;
  if (icon_name === "bath") html = <Bath css={style} />;
  if (icon_name === "wc") html = <WC css={style} />;
  if (icon_name === "non_conforme") html = <NonConforme css={style} />;
  if (icon_name === "conforme") html = <Conforme css={style} />;
  if (icon_name === "inconnu") html = <Inconnu css={style} />;
  if (icon_name === "caisson") html = <Caisson css={style} />;
  if (icon_name === "guide") html = <Guide css={style} />;
  if (icon_name === "escalier") html = <Escalier css={style} />;
  if (icon_name === "simple-flux") html = <SimpleFlux css={style} />;
  if (icon_name === "double-flux") html = <DoubleFlux css={style} />;
  if (icon_name === "individuelle") html = <Individuelle css={style} />;
  if (icon_name === "mutualisee") html = <Mutualisee css={style} />;
  if (icon_name === "ensemble") html = <Ensemble css={style} />;
  if (icon_name === "pression") html = <Pression css={style} />;
  if (icon_name === "debit") html = <Debit css={style} />;
  if (icon_name === "entree") html = <Entree css={style} />;
  if (icon_name === "cuisine") html = <Cuisine css={style} />;
  if (icon_name === "table") html = <Table css={style} />;
  if (icon_name === "renovation") html = <Renovation css={style} />;
  if (icon_name === "extension") html = <Extension css={style} />;
  if (icon_name === "plume") html = <Plume css={style} />;
  if (icon_name === "gallery") html = <Gallery css={style} />;
  return <div>{html}</div>;
}

export default Icon1;
